import React from 'react'
import PropTypes from 'prop-types'
import {useCustomPreferenceWithLocale} from '../hooks/use-custom-preference'
import {useGetIntegrations} from '../custom-api/hooks/use-get-integrations'

export const IntegrationsInitializer = ({children}) => {
    const bazaarVoiceConfigPerCountry = useCustomPreferenceWithLocale('bazaarVoiceConfigJson') || {}
    const feefoConfigurationPerCountry = useCustomPreferenceWithLocale('feefoConfiguration') || {}

    useGetIntegrations(bazaarVoiceConfigPerCountry, feefoConfigurationPerCountry)

    return <>{children}</>
}

IntegrationsInitializer.propTypes = {
    children: PropTypes.node,
}
